import { w } from "@/api/words";

import type { SurfaceMeta } from "../registry";

// Объявление поверхности S-06 «Постійні витрати» (F-022). Тека с этим файлом — и есть
// регистрация (`../registry.ts`): пункт «Постійні витрати» раздела «ГРОШІ» оживает
// вместе с ней (решение 028). Вход — пункт меню, строка регулярных `S-01` и прямой адрес.
export const meta: SurfaceMeta = {
  code: "S-06",
  // Название — слово словаря по коду (`G117`), читается при показе.
  get title_uk() {
    return w("s06_title");
  },
  path: "/s-06",
};
